<template>
    <div class="header" :style="style">
        <div class="header-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h1 class="display-5">{{ title }}</h1>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'pageHeader',
    props: {
        image: {
            type: String
        },
        title: {
            type: String
        }
    },
    computed: {
        style() {
            var url = require('../assets/images/' + this.image);
            return 'background: url(' + url + ') no-repeat center center';
        }
    }
}
</script>

<style scoped lang="scss">		
	.header {
        height: 20em;
        text-align: center;
        background: url(../assets/images/header2.jpg) no-repeat center center; 
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        position: relative;
    }

    .header-title {     
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 100%;
        background-color: rgba(255, 255, 255, 0.25);
        text-shadow: -1px 0 rgba(255, 255, 255, 0.45), 0 1px rgba(255, 255, 255, 0.45), 1px 0 rgba(255, 255, 255, 0.45), 0 -1px rgba(255, 255, 255, 0.45);
        -moz-box-shadow: 0 0 12px 12px rgba(255, 255, 255, 0.25);
        -webkit-box-shadow: 0 0 12px 12px rgba(255, 255, 255, 0.25);
        box-shadow: 0 0 12px 12px rgba(255, 255, 255, 0.25);
    }

	@include md {
        .header-title h1 {
			font-size: 6rem;
		}
    }
</style>
